fx.ns("models", class CustomColor extends fx.Model {

	constructor(data)
	{
		super(data);
    }
	
});